
import { useState, useEffect } from 'react';
import { getShops } from '@/lib/supabase/shops';

export const useShopName = (shopId?: string) => {
  const [shopName, setShopName] = useState<string>('');
  const [shopSlug, setShopSlug] = useState<string>('');
  
  useEffect(() => {
    const fetchShopName = async () => {
      if (shopId) {
        try {
          console.log(`Recherche du nom de la boutique pour l'ID: ${shopId}`);
          const shops = await getShops();
          const shop = shops.find(shop => shop.id === shopId);
          
          if (shop) {
            console.log(`Nom de boutique trouvé: ${shop.name}`);
            setShopName(shop.name);
            
            if (shop.slug) {
              console.log(`Slug de boutique trouvé: ${shop.slug}`);
              setShopSlug(shop.slug);
            } else {
              // Générer un slug à partir du nom si non disponible
              const generatedSlug = shop.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '');
              console.log(`Slug généré à partir du nom: ${generatedSlug}`);
              setShopSlug(generatedSlug);
            }
          } else {
            console.log(`Aucune boutique trouvée avec l'ID: ${shopId}`);
            setShopName('');
            setShopSlug('');
          }
        } catch (error) {
          console.error('Erreur lors de la récupération des détails de la boutique:', error);
          setShopName('');
          setShopSlug('');
        }
      }
    };
    
    fetchShopName();
  }, [shopId]);
  
  return { shopName, shopSlug };
};
